import { render, staticRenderFns } from "./MoreForm.vue?vue&type=template&id=77527826&scoped=true&"
import script from "./MoreForm.vue?vue&type=script&lang=js&"
export * from "./MoreForm.vue?vue&type=script&lang=js&"
import style0 from "./MoreForm.vue?vue&type=style&index=0&id=77527826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77527826",
  null
  
)

export default component.exports